import { routes } from "../../content/routes";
import { blogIndex } from "../../content/blogIndex.mjs";

export interface BlogMeta {
  title: string;
  description: string;
  featuredImage: {
    src: string;
    alt: string;
  };
  category: string;
  publishedAt: string;
}
export interface BlogItem {
  slug: string;
  path: string;
  meta: BlogMeta;
}

export function getBlogs(): BlogItem[] {
  return routes
    .map((route) => {
      const meta = blogIndex[route.slug as keyof typeof blogIndex];
      if (!meta) return null;
      return {
        slug: route.slug,
        path: route.path,
        meta,
      };
    })
    .filter(Boolean) as BlogItem[];
}
